import { defineMessages } from 'react-intl';

import imagePandoraLogo from '../../static/images/logo_pandora.png';

export const BlueBarButtons = Object.freeze({
  PANDORA_PLUS: 'PANDORA_PLUS',
  RELOAD: 'RELOAD',
});

/* UNSUPPORTED BROWSER */
export const pandoraLogo = imagePandoraLogo;
export const troubleshootingUrl =
  'https://help.pandora.com/customer/en/portal/topics/7282-troubleshooting/articles';
export const microsoftEdgeUrl = 'https://www.microsoft.com/en-us/edge';

export const unsupportedBrowserStrings = defineMessages({
  unsupportedHeaderMessageString: {
    id: 't.unsupportedHeaderMessageString',
    defaultMessage:
      'Your browser is out of date. Upgrade your browser for the full Pandora experience.',
  },
  unsupportedHeaderButtonString: {
    id: 't.unsupportedHeaderButtonString',
    defaultMessage: 'Update Now',
  },
  unsupportedTitleString: {
    id: 't.unsupportedBrowserTitle',
    defaultMessage: 'Your browser is no longer supported',
  },
  unsupportedMessageString: {
    id: 't.unsupportedBrowserMessage',
    defaultMessage:
      'Please upgrade your browser to enjoy Pandora.com. Download the latest version of one of these great browsers and you will be on your way.',
  },
  outdatedTitleString: {
    id: 't.outdatedBrowserTitle',
    defaultMessage: 'Your browser is out of date',
  },
  outdatedMessageString: {
    id: 't.outdatedBrowserMessage',
    defaultMessage:
      'A browser update is not required, but it is strongly recommended for an optimal experience. Use the links below to upgrade to the latest version of your existing browser.',
  },
  postscriptString: {
    id: 't.unsupportedBrowserFooter',
    defaultMessage:
      'Already upgraded but still having problems? Check out our {troubleshooting} tips.',
  },
  postscriptLinkString: {
    id: 't.unsupportedLinkText',
    defaultMessage: 'troubleshooting',
  },
  unsupportedIE11MessageString: {
    id: 't.unsupportedIE11MessageString',
    defaultMessage:
      'Microsoft Explorer was replaced by their new browser, Microsoft Edge. To continue using Pandora, please upgrade to',
  },
  unsupportedIE11ButtonString: {
    id: 't.unsupportedIE11ButtonString',
    defaultMessage: 'Microsoft Edge.',
  },
});

/* ACCOUNT MESSAGES */
const WEB_PREFIX = 'w.';
export const AccountMessageBlueBars = {
  INVALID_INFO_MESSAGE: WEB_PREFIX + 'invalid_demographic_info',
  UPDATE_INFO_MESSAGE: WEB_PREFIX + 'update_demographic_info',
  UPDATE_EMAIL_MESSAGE: WEB_PREFIX + 'invalid_email',
  UPDATE_ZIP_CODE_MESSAGE: WEB_PREFIX + 'invalid_zip_code',
};

export const accountMessageStrings = defineMessages({
  invalidInfoMessage: {
    id: 't.invalidInfoMessage',
    defaultMessage: 'Oops! We noticed your account information is inaccurate.',
  },
  confirmInfoMessage: {
    id: 't.confirmInfoMessage',
    defaultMessage: 'Please confirm your account information.',
  },
  outdatedZipMessage: {
    id: 't.outdatedZipMessage',
    defaultMessage: 'We noticed your ZIP code may be out of date',
  },
  invalidEmailMessage: {
    id: 't.invalidEmailMessage',
    defaultMessage: 'We noticed your email is invalid',
  },
  fixNowButton: {
    id: 't.fixNowButton',
    defaultMessage: 'Fix Now',
  },
});

/* RELOAD MESSAGES */
export const reloadMessageBlueBar = WEB_PREFIX + 'reload_browser_message';

export const ReloadMessageStrings = defineMessages({
  reloadNow: {
    id: 't.reloadBrowserMessage',
    defaultMessage: 'We have updated the Pandora website. Reload to use the latest version.',
  },
  reloadButton: {
    id: 't.reloadButton',
    defaultMessage: 'Reload',
  },
});

export const adBlockerMessageStrings = defineMessages({
  adBlockerInfoMessage: {
    id: 't.adBlockInfoMessage',
    defaultMessage:
      'Ad blocker is on: To prevent playback issues, you’ll need to allowlist Pandora.',
  },
  adsShowMeHowButton: {
    id: 't.adsShowMeHow',
    defaultMessage: 'Show me how',
  },
});
